import { useQuery } from '@apollo/client';
import { GET_PRODUCTION_ORDER } from '@retainerclub/shared-api';
import PropTypes from 'prop-types';
import { LoadingOrError } from '../../../shared';
import WarrantyFormInner from './WarrantyFormInner';

function WarrantyForm({
  productionOrderId,
  isModal = false,
  onClose,
  refetch = null,
}) {
  const { data, loading, error } = useQuery(GET_PRODUCTION_ORDER, {
    variables: { id: productionOrderId },
  });

  const shouldRender = LoadingOrError({
    loading,
    error,
    data,
    dataKey: 'productionOrder',
    title: 'Record',
  });

  if (shouldRender === true) {
    return (
      <WarrantyFormInner
        productionOrder={data?.productionOrder}
        isModal={isModal}
        onClose={onClose}
        refetch={refetch}
      />
    );
  }

  return shouldRender;
}

WarrantyForm.propTypes = {
  productionOrderId: PropTypes.string.isRequired,
  isModal: PropTypes.bool,
  onClose: PropTypes.func,
  refetch: PropTypes.func,
};

export default WarrantyForm;
